(function($, document, undefined){
	var	$doc	=	$(document);
	//附件上传
	(function(){
		$doc.on('change','.J_k_fileUpload [type=file]',function(){
			var	$this	=	$(this),
				name	=	$this.val().replace(/^[\s\S]+[\\]{1}/,''),
				del		=	$this.attr('data-del');
			$this.val()!='' && $this.closest('.J_k_fileUpload').children('ul').empty().append('<li><span '+ (del=='true'?'class="del"':'') +' title="'+ name +'">'+ name + (del=='true'?'<i data-name="del">x</i>':'') +'</span></li>');
		}).on('click','.J_k_fileUpload [data-name="del"]',function(){
			var	$this	=	$(this),
				$li		=	$this.closest('li'),
				$file	=	$li.parents('.J_k_fileUpload').find('[type=file]');
			$li.remove();
			$file.val('');
		});
	})();

	//伪下拉框
	(function(){
		var	$box	=	$('[data-name=k_select]'),init,_init;
		// if(!$box.length)return false;
		init	=	function(element, index){
			var	$this	=	$(element),
				$input	=	$this.find('[data-name=selectInput]'),
				$select	=	$this.find('.J_k_select'),
				isClick	=	$select.find('.active').length,
				$active	=	(isClick?$this.find('.active'):$select.find('li').eq(0)),
				fn;
			$this.find('input[type=hidden]').val($active.attr('data-value'));
			$input.attr('data-index',index).find('[data-name=val]').text($active.text());
			$select.attr('data-index',index).find('li').eq(0).addClass('first'+(isClick?'':' active')).end().eq(-1).addClass('last');
			//$select.attr('data-index',index).clone(true).appendTo('body');
			//$select.remove();
            $this.on('click','[data-name=selectInput]',function(){
                var	$this	=	$(this),
                    _index	=	$this.attr('data-index');
                $('.J_k_select').hide();
                $('.J_k_select[data-index='+ _index +']').show();
                //_init(_index);
                return false;
            });
            /*$(window).on('resize',function(){
                $('[data-name=selectInput]').each(function(index){
                    _init(index);
                });
            });*/
		};
        $.k_selectInit = function(){
            $('[data-name=k_select]').each(function(index){
                init(this, index);
            });
        };
		/*_init	=	function(index){
			var	$input	=	$('[data-name=selectInput][data-index='+ index +']'),
				$select	=	$('.J_k_select[data-index='+ index +']');
			setTimeout(function(){
				//$select.css({'top':(+$input.offset().top + (+$input.outerHeight())),'left':$input.offset().left});
			},50);
		};*/
		$box.each(function(index){
			init(this, index);
		});
        $doc.on('click',function(){
            $('.J_k_select').hide();
        }).on('click','.J_k_select',function(){
            return false;
        }).on('click','.J_k_select li',function(){
            var	$this	=	$(this),
                $parent	=	$this.closest('.J_k_select'),
                $input	=	$('[data-name=selectInput][data-index='+ $parent.attr('data-index') +'] [data-name=val]');
            $this.addClass('active').siblings().removeClass('active');
            $input.text($this.text()).parent().siblings('input[type=hidden]').val($this.attr('data-value'));
            $parent.hide();
        });
	})();

	//标签页
	(function(){
		var	$tab	=	$('.J_k_tabPage');
		if(!$tab.length)return false;
		function init(_this){
			var	$box	=	$(_this),
				$active	=	$box.find('.nav li.active'),
				index;
			if($active.length){
				index	=	$active.index();
			}else{
				index	=	0;
			};
			$box.find('.main li.page').eq(index).show().siblings().hide();
		};
		$tab.each(function(){
			init(this);
		});
		$.fn.k_pageTab	=	function(){
			init(this);
			return this;
		};
		$doc.on('click','.J_k_tabPage .nav li',function(){
			var	$this	=	$(this),
				$page	=	$this.closest('.J_k_tabPage').find('.main li.page');
			$this.addClass('active').siblings().removeClass('active');
			$page.eq($this.index()).show().siblings().hide();
		});
	})();

	//数组去重
	k_norepeat = function(arr) {
		var	_arr	=	[],
			json	=	{};
		for(var	i=0,max=arr.length; i<max; i++){
			if(!json[arr[i]]){
				json[arr[i]] = 1;
				_arr.push(arr[i]);
			};
		};
		return _arr
	};

	//组信息选择弹层
	$.k_selectUsers = function(that, d) {
		var	userForm	=	'',
			$that		=	$(that),
			name		=	$that.attr('data-name'),
			mode		=	$that.attr('data-mode'),
			_this		=	this;
		//编辑id数组生成
		function addIds(){
			var	$li	=	$that.siblings('ul').find('li'),
				arr	=	[];
			for(var	i=0,max=$li.length; i<max; i++){
				arr.push($li.eq(i).attr('data-id'));
			};
			return arr;
		};
		//编辑id判断
		function hasId(id){
			var	_ids	=	addIds();
			for(var i=0,max=_ids.length; i<max; i++){
				if(_ids[i]	==	id.userId)return true;
			};
			return false;
		};
		//组信息解析拼接结构
		function group(json, first){
			var	json	=	json || {},
				first	=	first == false?false:true,
				html	=	'';
			if($.isArray(json)){
				for(var	i=0,max=json.length; i<max; i++){
					html	+= group(json[i], (i==0?true:false));
				};
			}else{
				html	+= '<li class="J_k_root '+ (first?'active':'') +'">'+
								'<div class="name"><b class="left"></b><div class="gpName">'+ json.orgName +'</div><i class="arrow">></i><b class="right"></b></div>'+
								'<div class="main">'+
									'<div class="userBox">'+ grpRound(json, true) +'</div>'+
									'<div class="btnBox"><button class="k_btn J_k_close white long mr20">取消</button><button class="k_btn J_k_sure long">确定</button></div>'+
								'</div>'+
							'</li>';
			};
			return html;
		};
		//结构循环
		function grpRound(json, first, mt){
			var	bool	=	first==true?true:false,
				html	=	'<div class="line '+ (mt?'mt15':'') +'">';
			if(json.orgName && !bool){
				html	+=	'<label class="title '+ (mode=='checkbox'?'check':'') +'">'+ (mode=='checkbox'?'<div class="k_checkbox" data-name="checkbox"><input type="checkbox" /></div>':'') + json.orgName +'</label><div class="J_k_ceng">';
			};
			if(json.users){
				html	+=	'<ul>';
				for(var	i=0,max=json.users.length; i<max; i++){
					html	+=	'<li><label class="check'+ (mode=='radio' && hasId(json.users[i])?' active':'') +'" '+ (mode=='checkbox'?'':'data-id="'+ json.users[i].userId +'"') +'>'+ (mode=='checkbox'?'<div class="k_checkbox '+ (hasId(json.users[i])?'active':'') +'" data-name="checkbox"><input type="checkbox" data-id="'+ json.users[i].userId +'" '+ (hasId(json.users[i])?'checked=""':'') +' /></div>':'') + json.users[i].name +'</label></li>';
				};
				html	+=	'</ul>';
			};
			if(json.subOrgs){
				for(var	j=0,max2=json.subOrgs.length; j<max2; j++){
					html	+=	grpRound(json.subOrgs[j],false,(first?1:0));
				};
			};
			if(json.orgName && !bool){
				html	+=	'</div>';
			};
			html	+=	'</div>';
			return html;
		};
		//全选层级判断
		function allCheck($that){
			var	$input	=	$that.parents('.J_k_ceng').eq(0).find('input[type=checkbox]'),
				all		=	1,
				$fa		=	$that.parents('.J_k_ceng').eq(0).prev().find('input[type=checkbox]');
			for(var	i=0,max=$input.length; i<max; i++){
				if($input.eq(i).prop('checked') != all){
					all	=	0;
				};
			};
			$fa.prop('checked',all)
			if(all){
				$fa.parent().addClass('active');
			}else{
				$fa.parent().removeClass('active');
			};
			$fa.length && allCheck($fa);
		};
		//同一个用户所属多组时交互
		function roundCheck($this){
			$this.parents('.J_k_userModal').find('[data-id='+ $this.attr('data-id') +']').each(function(){
				var	$_this	=	$(this);
				$_this.prop('checked',$this.prop('checked'));
				$_this.parent()[$this.prop('checked')?'addClass':'removeClass']('active');
				allCheck($_this);
			});
		};
		(function _ajax(){
			if(d.status){
				var	data	=	d.data,
					html	=	'<div class="J_k_userModal k_userModal" data-mode="'+ name +'">'+
									'<div class="box">'+
										'<div class="tanTitle">'+ d.title +'<i class="J_k_close"></i></div>'+
										'<ul class="k_nav">';
				html	+=	group(data);
				html	+=				'</ul>'+
									'</div>'+
									'<div class="bg"></div>'+
								'</div>';
				$(html).appendTo('body').on('click','.box',function(e){
					e.stopPropagation();
				}).on('click','.J_k_root',function(){
					$(this).addClass('active').siblings().removeClass('active');
				}).on('click','.J_k_root [data-name=checkbox]',function(){
					var	$this	=	$(this),
						$input	=	$this.children('input');
					$input.prop('checked',$input.is(':checked'));
					if($input.attr('data-id') == undefined){
						var	$child	=	$input.parents('.line').eq(0).find('input[type=checkbox]');
						$child.prop('checked',$input.prop('checked')).each(function(){
							roundCheck($(this));
						});
					}else{
						roundCheck($input);
					};
				}).on('change','.J_k_root input[type=checkbox]',function(){
					var	$this	=	$(this);
					$this.parent()[$this.is(':checked')?'addClass':'removeClass']('active');
				}).on('click','.J_k_close',function(e){
					$(e.target).parents('.J_k_userModal').hide();
				}).on('click','.J_k_sure',function(e){
					var	$this	=	$(this),
						arr		=	[],
						html	=	'',
						userArr	=	[];
					if(mode	==	'checkbox'){
						var	$checked	=	$this.parents('.J_k_userModal').find('input[type=checkbox]:checked');
						for(var	i=0,max=$checked.length; i<max; i++){
							if($checked.eq(i).attr('data-id') != undefined){
								arr.push($checked.eq(i).attr('data-id'));
								userArr.push($checked.eq(i).parent().parent().text());
								arr = k_norepeat(arr);
								userArr = k_norepeat(userArr);
							};
						};
					}else if(mode	==	'radio'){
						var	$checked	=	$this.parents('.J_k_userModal').find('label.active');
						arr.push($checked.attr('data-id'));
						userArr.push($checked.text());
						arr = k_norepeat(arr);
						userArr = k_norepeat(userArr);
					};
					for(var	j=0,max2=userArr.length; j<max2; j++){
						html	+=	'<li data-id='+ arr[j] +'><span class="del">'+ userArr[j] +'<i>x</i></span></li>';
					};
					$that.siblings('ul').empty().append(html);
					$(e.target).parents('.J_k_userModal').hide();
				}).on('click','ul>li>label',function(){
					if(mode=='radio'){
						var	$this	=	$(this);
						$this.parents('.J_k_userModal').eq(0).find('ul>li>label').removeClass('active');
						$this.addClass('active');
					};
				});
				$('.J_k_root input[type=checkbox][checked]').each(function(){
					allCheck($(this));
				});
				$doc.on('click',function(e){
					$(e.target).parents('.J_k_userModal').hide();
				}).on('click','[data-name='+$that.attr('data-name')+']+ul i',function(){
					var	$this		=	$(this),
						$li			=	$this.closest('li'),
						$checked	=	$('[data-mode='+ $that.attr('data-name') +'] input[type=checkbox]:checked');
					for(var	i=0,max=$checked.length ;i<max; i++){
						var	$isMe	=	$checked.eq(i);
						if($isMe.attr('data-id') == $li.attr('data-id')){
							$isMe.prop('checked',false).parent()[$this.is(':checked')?'addClass':'removeClass']('active');
							roundCheck($isMe);
						};
					};
					$li.remove();
				});
			};
		})();
	};

	//弹窗
	$.k_tan = function(title,_html, width, height){
		var	_html	=	_html==undefined?'' : _html,
			title	=	title==undefined?'' : title,
			html	=	'';
		html	=	'<div class="k_tan J_k_tan" style="display:block;">'+
							'<div class="k_tanMain J_k_tanMain" style="width:'+ width +'px;height:'+ height +'px;margin-top:-'+ height/2 +'px;margin-left:-'+ width/2 +'px;">'+
								'<div class="title color28">'+ title +'<i class="close J_k_close"></i></div>'+
								'<div class="main">'+ _html +'</div>'+
							'</div>'+
							'<div class="bg J_k_bg"></div>'+
						'</div>';
		$(html).appendTo('body').on('click','.J_k_close,.J_k_bg',function(){
			$('.J_k_tan').hide();
		});
	};

    //ajax模拟返回数据
	$.ajaxgo = function(url, fn, demo, data, method, datatype) {
        fn = fn || Fn;
        url == 'javascript:;' ? fn(demo) : $[method || 'post'](url, data, fn, datatype || 'json');
	};

	//UI组件 组信息选择弹层demo
	(function(){
		if(!$('[data-form="selectUser"]').length || !$('[data-name="demo1"]').length)return false;
		//d为模拟后端返回数据，根据实际情况应该是ajax获取
		var	d	=	{status:true,title:'标题样式12号字，字色#282828，左边距20px',data:[{"orgId":3,"users":[{"userId":2,"name":"zzz(同属多组)"},{"userId":5,"name":"aaa"}],"subOrgs":[{"orgId":5,"users":[{"userId":3,"name":"bbb"}],"orgName":"第一小分队"},{"orgId":6,"users":[{"userId":4,"name":"ccc"}],"orgName":"第二小分队"}],"orgName":"突击小队1队"},{"orgId":4,"users":[{"userId":6,"name":"ddd"},{"userId":7,"name":"eee"}],"subOrgs":[{"orgId":7,"users":[{"userId":8,"name":"fff"}],"orgName":"空战1队"},{"orgId":8,"users":[{"userId":2,"name":"zzz(同属多组)"}],"orgName":"空战2队"}],"orgName":"突击小队2队"}]},
			d2	=	{"status":true,title:'标题样式12号字，字色#282828，左边距20px',"state":"0","info":"成功","data":{"orgId":2,"users":[{"userId":6,"name":"马超"}],"subOrgs":[{"orgId":3,"users":[{"userId":2,"name":"关羽"},{"userId":5,"name":"张飞"}],"subOrgs":[{"orgId":5,"users":[{"userId":3,"name":"关兴"}],"orgName":"初一语文组"},{"orgId":6,"users":[{"userId":4,"name":"关平"}],"orgName":"初二语文组"}],"orgName":"语文组"},{"orgId":4,"users":[{"userId":9,"name":"曹操"}],"subOrgs":[{"orgId":9,"users":[{"userId":10,"name":"徐晃"},{"userId":11,"name":"张辽"}],"orgName":"初二数学组"},{"orgId":10,"users":[{"userId":12,"name":"郭嘉"},{"userId":13,"name":"荀彧"}],"orgName":"初三数学组"}],"orgName":"数学组"}],"orgName":"中山中学"}};
		$('[data-form="selectUser"]').each(function(){
			new	$.k_selectUsers(this, d);
		});
		$doc.on('click','[data-form="selectUser"]',function(){
			$('[data-mode='+ $(this).attr('data-name') +']').show();
		});
	})();
})(jQuery, document);
